import { Redirect, Route, Router, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import React, { lazy, Suspense, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Cookies from 'js-cookie';
import qs from 'qs';
import LayoutA from './layouts/layoutA'; // has footer
import LayoutB from './layouts/layoutB'; // no footer
import LayoutC from './layouts/layoutC'; // no header, footer
import RouterListener from '@/components/routerListener';
import { useStore } from './models';
import { getQuery, getExchangeUrl } from '@/utils/location';
import UnderLyingEnum from '@/@enums/UnderLyingEnum';
import { AmountUnitEnum, Unit } from '@/@enums/Unit';
import device from '@/utils/device';
import { isFromMobile } from '@/utils/location';

const layoutWrap = (component: any, layout = LayoutA, layoutProps = {}): React.FC<any> => {
  const Component = component;
  const Layout = layout;
  const wrap: React.FC<any> = props => (
    <Layout {...layoutProps}>
      <Component {...props} />
    </Layout>
  );
  return wrap;
};

const AsyncFuture = layoutWrap(
  lazy(() => import('./pages/futures/main')),
  LayoutB,
);
const AsyncFindpsw = layoutWrap(
  lazy(() => import('./pages/account/findPsw')),
  LayoutA,
);
const AsyncLogin = layoutWrap(
  lazy(() => import('./pages/account/signIn')),
  LayoutA,
);
const AsyncOrder = layoutWrap(
  lazy(() => import('./pages/futures/record')),
  LayoutA,
);

const AsyncInformation = layoutWrap(
  lazy(() => import('./pages/futures/information')),
  LayoutA,
);

const AsyncStepRate = layoutWrap(
  lazy(() => import('./pages/futures/stepRate')),
  LayoutA,
);
const AsyncBindGoogle = layoutWrap(
  lazy(() => import('./pages/account/profile/components/bindGoogle')),
  LayoutA,
);
const AsyncChangeGoogle = layoutWrap(
  lazy(() => import('./pages/account/profile/changeGoogle')),
  LayoutA,
);
const AsyncBindPhone = layoutWrap(
  lazy(() => import('./pages/account/profile/bindPhone')),
  LayoutA,
);
const AsyncBindEmail = layoutWrap(
  lazy(() => import('./pages/account/profile/bindEmail')),
  LayoutA,
);
const AsyncChangePwd = layoutWrap(
  lazy(() => import('./pages/account/profile/changePwd')),
  LayoutA,
);
const AsyncSignUp = layoutWrap(
  lazy(() => import('./pages/activity/signUp')),
  LayoutC,
);
const AsyncDownload = layoutWrap(
  lazy(() => import('./pages/download')),
  LayoutC,
);
const AsyncDownloadPage = layoutWrap(
  lazy(() => import('./pages/downloadPage')),
  device.desktop() ? LayoutA : LayoutC,
);
const AsyncHome = layoutWrap(
  lazy(() => import('./pages/home')),
  LayoutA,
);

const RegisterEntry: React.FC = () => {
  const { invite } = useParams<{ invite?: string }>();
  const { search } = useLocation();
  const { replace } = useHistory();
  const { ui } = useStore();

  useEffect(() => {
    const { username } = qs.parse(search, { ignoreQueryPrefix: true });
    const registerValue = typeof username === 'string' ? username : '';

    ui.showRegisterModal({
      registerValue,
      inviteCode: invite || '',
    });
    replace('/');
  }, [invite, replace, search, ui]);

  return null;
};
const AsyncSummer = layoutWrap(
  lazy(() => import('./pages/activity/summer')),
  LayoutA,
  {
    transparent: true,
  },
);
const AsyncOtcConsumer = layoutWrap(
  lazy(() => import('./pages/otc/consumer/quick')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncFollow = layoutWrap(
  lazy(() => import('./pages/follow/fundBill')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncOtcAllPayments = layoutWrap(
  lazy(() => import('./pages/otc/consumer/allPayments')),
  LayoutA,
  {
    transparent: true,
  },
);
const QuickBuy = layoutWrap(
  lazy(() => import('./pages/otc/consumer/quickBuy')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncOtcBuyOrSellOrder = layoutWrap(
  lazy(() => import('./pages/otc/consumer/buyOrSellOrder')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncOtcPayOrder = layoutWrap(
  lazy(() => import('./pages/otc/consumer/orderInfo')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncOtcPersonalCenter = layoutWrap(
  lazy(() => import('./pages/otc/consumer/personalCenter')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncOtcAdvertiser = layoutWrap(
  lazy(() => import('./pages/otc/advertiser')),
  LayoutA,
  {
    transparent: true,
  },
);
const AsyncReceipt = layoutWrap(
  lazy(() => import('./pages/otc/advertiser/receipt')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncMarket = layoutWrap(
  lazy(() => import('./pages/market')),
  LayoutA,
  {
    transparent: true,
  },
);
const AsyncOtcPublish = layoutWrap(
  lazy(() => import('./pages/otc/advertiser/publish')),
  LayoutA,
  {
    transparent: true,
  },
);
const AsyncSpot = layoutWrap(
  lazy(() => import('./pages/spot/main')),
  LayoutB,
);
const AsyncOtcOrder = layoutWrap(
  lazy(() => import('./pages/otc/advertiser/order')),
  LayoutA,
  {
    transparent: true,
  },
);

const AsyncBasic = layoutWrap(
  lazy(() => import('./pages/account/profile/basic')),
  LayoutA,
);
const AsyncInvite = layoutWrap(
  lazy(() => import('./pages/account/profile/invite')),
  LayoutA,
);
const AsyncSecurity = layoutWrap(
  lazy(() => import('./pages/account/profile/security')),
  LayoutA,
);
const AsyncloginRecord = layoutWrap(
  lazy(() => import('./pages/account/profile/loginRecord')),
  LayoutA,
);
const AsyncDeviceRecord = layoutWrap(
  lazy(() => import('./pages/account/profile/deviceRecord')),
  LayoutA,
);
const AsyncVerified = layoutWrap(
  lazy(() => import('./pages/account/profile/verified')),
  LayoutA,
);
const AsyncSetting = layoutWrap(
  lazy(() => import('./pages/account/profile/setting')),
  LayoutA,
);

const AsyncApi = layoutWrap(
  lazy(() => import('./pages/account/profile/api')),
  LayoutA,
);
const AsyncContract = layoutWrap(
  lazy(() => import('./pages/account/assets/contract')),
  LayoutA,
);
const AsyncHistory = layoutWrap(
  lazy(() => import('./pages/account/assets/history')),
  LayoutA,
);
const AsyncAddress = layoutWrap(
  lazy(() => import('./pages/account/assets/address')),
  LayoutA,
);
const AsyncAssetsSpot = layoutWrap(
  lazy(() => import('./pages/account/assets/spot')),
  LayoutA,
);
const AsyncAssetsCopy = layoutWrap(
  lazy(() => import('./pages/account/assets/copy')),
  LayoutA,
);
const AsyncOtcAssets = layoutWrap(
  lazy(() => import('./pages/account/assets/otc')),
  LayoutA,
);

const AsyncFinanceAssets = layoutWrap(
  lazy(() => import('./pages/account/assets/finance')),
  LayoutA,
);
const AsyncTotal = layoutWrap(
  lazy(() => import('./pages/account/assets/total')),
  LayoutA,
);
const AsyncAssetsTransfer = layoutWrap(
  lazy(() => import('./pages/account/assets/assetsTransfer')),
  LayoutA,
);
const AsyncDeposits = layoutWrap(
  lazy(() => import('./pages/account/assets/deposits')),
  LayoutA,
);
const AsyncWithdraws = layoutWrap(
  lazy(() => import('./pages/account/assets/withdraws')),
  LayoutA,
);
const AsyncInnerTransfer = layoutWrap(
  lazy(() => import('./pages/account/assets/innerTransfer')),
  LayoutA,
);

const AsyncSpotOrder = layoutWrap(
  lazy(() => import('./pages/order/spotOrder')),
  LayoutA,
);
const AsyncContractOrder = layoutWrap(
  lazy(() => import('./pages/order/contractOrder')),
  LayoutA,
);

const AsyncFinance = layoutWrap(
  lazy(() => import('./pages/finance/index')),
  LayoutA,
);
const AsyncFinanceProduct = layoutWrap(
  lazy(() => import('./pages/finance/product')),
  LayoutA,
);
const AsyncFinanceCurrent = layoutWrap(
  lazy(() => import('./pages/finance/current')),
  LayoutA,
);
const AsyncFinanceMyProducts = layoutWrap(
  lazy(() => import('./pages/finance/myProducts')),
  LayoutA,
);
const AsyncStaking = layoutWrap(
  lazy(() => import('./pages/finance/staking')),
  LayoutA,
);
const AsyncCloudcomputing = layoutWrap(
  lazy(() => import('./pages/finance/cloudcomputing')),
  LayoutA,
);
const AsyncLending = layoutWrap(lazy(() => import('./pages/finance/lending')));

const AsyncApply = layoutWrap(
  lazy(() => import('./pages/otc/advertiser/apply')),
  LayoutA,
);
const AsyncUpdateMyAdv = layoutWrap(
  lazy(() => import('./pages/otc/advertiser/updateMyAdv')),
  LayoutA,
);
const AsyncTest = layoutWrap(
  lazy(() => import('./pages/test')),
  LayoutC,
);
const AsyncMessage = layoutWrap(
  lazy(() => import('./pages/message')),
  LayoutA,
);
const RouteSwitch: React.FC = () => {
  const { ui, account, underlying, finance, futures } = useStore();
  const { pathname } = useLocation();
  const { setTheme, setIsShowSetting, setUnit, setIsConfirmAgain, setUBasedUnit, setCoinBasedUnit } = ui;
  const { setIsConfirmAgain: setFuturesConfirmAgain } = futures;

  const { isCanBuy, setIsCanBuy } = finance;

  const { setCurrentUnderLying } = underlying;

  const htmlDom = document.querySelector('html');
  const theme = localStorage.getItem('lvbitTheme') || 'light';
  htmlDom?.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
  // const theme = 'Dark';
  // htmlDom?.setAttribute('data-theme', 'dark');

  setTheme(theme as Theme);

  // 如果是交易界面，设置一些交易界面的信息
  if (/^(\/futures\/contract\/)/.test(pathname)) {
    // const theme = 'Light';
    const uBasedUnit = localStorage.getItem('uBasedUnit') || AmountUnitEnum.usdt;
    const coinBasedUnit = localStorage.getItem('coinBasedUnit') || AmountUnitEnum.usd;
    const isConfirmAgainStorage = localStorage.getItem('isConfirmAgain') || 'false';
    const underlyingType = /(\/u_based\/)/.test(pathname) ? UnderLyingEnum.U_BASED : UnderLyingEnum.COIN_BASED;
    setCurrentUnderLying(underlyingType);

    setIsShowSetting(true);
    setUBasedUnit(uBasedUnit as Unit);
    setCoinBasedUnit(coinBasedUnit as Unit);
    underlyingType === UnderLyingEnum.U_BASED
      ? setUnit(uBasedUnit as Unit, underlyingType)
      : setUnit(coinBasedUnit as Unit, underlyingType);
    const confirmAgain = isConfirmAgainStorage === 'true';
    setIsConfirmAgain(confirmAgain);
    setFuturesConfirmAgain(confirmAgain);
  } else {
    if (/^(\/step-rate)|(\/activity)/.test(pathname)) {
      const arr = window.location.href.split('?');
      // notice : android bug /activity/summer?token=&from=__from__&theme=__theme__&lang=cn&platform=__platform__&version=__version__?lang=cn&from=app&token=null&theme=light
      // 安卓需要将第二个?后面的内容移除掉
      if (arr.length > 2) {
        const url = window.location.href;
        const newUrl = url.replaceAll('?' + arr[arr.length - 1], '');
        window.location.href = newUrl;
      }
      // const theme = 'dark'; // 暂时只支持dark
      // if (device.isFromApp()) {
      //   theme = getUrlSearch('theme') || 'dark';
      // }

      // htmlDom?.setAttribute('data-theme', theme);
    } else {
      // htmlDom?.setAttribute('data-theme', '');
    }

    setIsShowSetting(false);
  }

  if (pathname.includes('finance')) {
    const isCanBuyStorage = localStorage.getItem('isCanBuy') || 'false';
    setIsCanBuy(JSON.parse(isCanBuyStorage));
  }
  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Route path="/futures/contract/:underlying/:symbolId" component={AsyncFuture} />
        <Route path="/futures/record/:tabKey?" component={AsyncOrder} />
        <Route path="/futures/information/:tabKey?" component={AsyncInformation} />
        <Route path="/futures/step-rate" component={AsyncStepRate} />
        <Route path="/futures/activity/summer" component={AsyncSummer} />
        <Route path="/futures/activity/sign-up" component={AsyncSignUp} />
        <Route path="/spot/trade/:symbolId" component={AsyncSpot} />
        <Route path="/register/:invite?" component={RegisterEntry} />
        <Route path="/login" component={AsyncLogin} />
        <Route path="/findpsw" component={AsyncFindpsw} />
        <Route path="/loadApp" component={AsyncDownload} />
        <Route path="/downloadApp" component={AsyncDownloadPage} />

        {/* 跟单 */}
        <Route path="/follow" component={AsyncFollow} />

        {/* otc */}
        <Route path="/account/otc/index" component={AsyncOtcConsumer} />
        <Route path="/account/otc/allPayments" component={AsyncOtcAllPayments} />
        <Route path="/account/otc/quickBuy/:type" component={QuickBuy} />
        <Route path="/account/otc/buyOrSellOrder" component={AsyncOtcBuyOrSellOrder} />
        <Route path="/account/otc/payOrder" component={AsyncOtcPayOrder} />
        <Route path="/account/otc/personalCenter" component={AsyncOtcPersonalCenter} />

        {/* 商家版 */}
        <Route path="/account/otc/advertiser/myAd" component={AsyncOtcAdvertiser} />
        <Route path="/account/otc/advertiser/publish" component={AsyncOtcPublish} />
        <Route path="/account/otc/advertiser/receipt" component={AsyncReceipt} />
        <Route path="/account/otc/advertiser/order" component={AsyncOtcOrder} />
        <Route path="/account/otc/advertiser/apply" component={AsyncApply} />
        <Route path="/account/otc/advertiser/update/:id?" component={AsyncUpdateMyAdv} />

        <Route path="/account/profile/basic" component={AsyncBasic} />
        <Route path="/account/profile/verified" component={AsyncVerified} />
        <Route path="/account/profile/setting" component={AsyncSetting} />
        <Route path="/account/profile/security/changeGoogle" component={AsyncChangeGoogle} />
        <Route path="/account/profile/security/bindGoogle" component={AsyncBindGoogle} />
        <Route path="/account/profile/security/changePwd" component={AsyncChangePwd} />
        <Route path="/account/profile/security/bindPhone" component={AsyncBindPhone} />
        <Route path="/account/profile/security/bindEmail" component={AsyncBindEmail} />
        <Route path="/account/profile/security/loginRecord" component={AsyncloginRecord} />
        <Route path="/account/profile/security/deviceRecord" component={AsyncDeviceRecord} />
        <Route path="/account/profile/security" component={AsyncSecurity} />
        <Route path="/account/profile/api" component={AsyncApi} />
        <Route path="/account/profile/invite" component={AsyncInvite} />
        <Route path="/account/assets/contract" component={AsyncContract} />
        <Route path="/account/assets/history/:type?" component={AsyncHistory} />
        <Route path="/account/assets/deposits" component={AsyncDeposits} />
        <Route path="/account/assets/withdraws" component={AsyncWithdraws} />
        <Route path="/account/assets/innerTransfer" component={AsyncInnerTransfer} />
        <Route path="/account/assets/address" component={AsyncAddress} />
        <Route path="/account/assets/spot" component={AsyncAssetsSpot} />
        <Route path="/account/assets/otc" component={AsyncOtcAssets} />
        <Route path="/account/assets/finance" component={AsyncFinanceAssets} />
        <Route path="/account/assets/copy" component={AsyncAssetsCopy} />

        <Route path="/account/assets/total" component={AsyncTotal} />
        <Route path="/account/assets/assetsTransfer" component={AsyncAssetsTransfer} />
        <Route path="/dealsmanagement/spot/:type?" component={AsyncSpotOrder} />
        <Route path="/futures/dealsmanagement/contract/:type?" component={AsyncContractOrder} />
        <Route path="/market" component={AsyncMarket} />
        {/* 理财 */}
        {/* <Route path="/finance/index/:type?" component={AsyncFinance} />
        <Route path="/finance/product" component={AsyncFinanceProduct} />
        <Route path="/finance/current" component={AsyncFinanceCurrent} />
        <Route path="/finance/staking" component={AsyncStaking} />
        <Route path="/finance/cloudcomputing" component={AsyncCloudcomputing} />
        <Route path="/finance/lending" component={AsyncLending} />
        <Route path="/finance/myProducts" component={AsyncFinanceMyProducts} />
        <Route path="/test" component={AsyncTest} /> */}

        <Route path="/message/:type?" component={AsyncMessage} />

        <Route path="/home" component={AsyncHome} />
        <Route path="/" component={!device.desktop() ? AsyncDownload : AsyncHome} />
      </Switch>
    </Suspense>
  );
};

interface Props {
  history: any;
}

const Routes: React.FC<Props> = props => {
  const { history } = props;
  const { ticker, account, spotTicker, otc, home, coin, asset } = useStore();
  const { fetchUserInfo, fetchCountryList, isLogin, fetchAccountInfo, userInfo } = account;

  const { fetchConf, getAppUrl } = home;
  const { fetchFoundTypeArr } = asset;
  const { fetchCoinsLogo } = coin;

  const { fetchOtcInfo, fetchSupportCoin } = otc;
  const futuresPreLoad = async () => {
    const { fetchUBasedSymbolConfigList, fetchCoinBasedSymbolConfigList, fetchCoinList } = ticker;
    await Promise.all([
      fetchUBasedSymbolConfigList(),
      fetchCoinBasedSymbolConfigList(),
      fetchCoinList(),
    ]);
    // allSymbolConfigList 由 setUBasedSymbolConfigList / setCoinBasedSymbolConfigList 内同步合并、排序

    const loading = document.querySelector('.init-loading-mask');
    loading?.parentNode?.removeChild(loading);
    if (isLogin) {
      fetchAccountInfo();
    }
  };

  const spotPreLoad = async () => {
    const { fetchSymbolConfigList, fetchCoinList } = spotTicker;
    await Promise.all([fetchSymbolConfigList(), fetchCoinList()]);

    const loading = document.querySelector('.init-loading-mask');
    loading?.parentNode?.removeChild(loading);
  };

  const preLoad = () => {
    // 从cookie中获取token
    getAppUrl('android');
    getAppUrl('ios_testflight');
    getAppUrl('ios_appstore');
    getAppUrl('google');
    fetchCountryList();

    fetchConf();
    fetchCoinsLogo();
    // 获取用户信息
    if (isLogin) {
      fetchUserInfo();
      fetchFoundTypeArr();
    }
  };

  const otcLoad = () => {
    // 从cookie中获取token

    // 获取用户信息
    if (isLogin) {
      fetchOtcInfo();
      fetchSupportCoin();
    }
  };

  useEffect(() => {
    preLoad();
    futuresPreLoad();
    spotPreLoad();

    if (/^(\/account\/otc)/g.test(history.location.pathname)) {
      otcLoad();
    }
  }, []);

  // 动态获取主域名的函数
  function getMainDomain() {
    const hostname = window.location.hostname; // 获取当前域名
    const parts = hostname.split('.');
    // 保证主域名至少有两部分（比如：`hashex.vip` 或 `example.co.uk`）
    if (parts.length > 2) {
      return `.${parts.slice(-2).join('.')}`; // 取最后两部分作为主域名
    }
    return `.${hostname}`; // 返回当前域名（本地测试时适用）
  }

  // 设置 Cookie
  function setSharedCookie(name: string, value: string | undefined, options = {}) {
    const domain = getMainDomain(); // 动态获取主域名
    const cookieStr = `${name}=${value}; path=/; domain=${domain}; secure; SameSite=None;`;
    document.cookie = cookieStr;
  }

  // React 组件
  useEffect(() => {
    const token = Cookies.get('token'); // 从 js-cookie 获取 Cookie
    if (isLogin) {
      if (token) {
        // setSharedCookie('token', token); // 动态设置共享 Cookie
      }
    }
  }, [isLogin, userInfo]);

  return (
    <Suspense fallback={<div />}>
      <Router history={history}>
        <RouterListener />
        <RouteSwitch />
      </Router>
    </Suspense>
  );
};

export default observer(Routes);
